module.exports = __webpack_public_path__ + "static/img/newLoad_xinli_bg1.c9077f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download/newLoad_xinli_bg1.png
// module id = sz2s
// module chunks = 3